import {
  type GetSavedItemsParams,
  SavedItem,
  SavedItems,
} from "@repo/apis/customers-saveditems-v3";

export const SAVED_ITEMS_SORT_OPTIONS = {
  DATE_ADDED: "date",
  PRICE: "price",
  DISCOUNT: "discount",
  STOCK_LEVEL: "stockLevel",
  RECENTLY_DISCOUNTED: "recentlyDiscounted",
} as const;

export const SAVED_ITEMS_SORT_ORDER = {
  ASC: "asc",
  DSC: "dsc",
} as const;

export const DEFAULT_PAGINATION = {
  LIMIT: 100,
  OFFSET: 0,
} as const;

type SavedItemsSortOptions = Pick<
  GetSavedItemsParams,
  "sort" | "sortOrder" | "limit" | "offset"
>;

export const createGetSavedItemsOptions = (
  overrides?: SavedItemsSortOptions,
): SavedItemsSortOptions => ({
  limit: DEFAULT_PAGINATION.LIMIT,
  offset: DEFAULT_PAGINATION.OFFSET,
  sort: SAVED_ITEMS_SORT_OPTIONS.DATE_ADDED,
  sortOrder: SAVED_ITEMS_SORT_ORDER.DSC,
  ...overrides,
});

const matchesProduct = (
  item: { productId: number; variantId?: number | null },
  productId: number,
  variantId?: number,
): boolean => {
  return (
    item.productId === productId && (!variantId || item.variantId === variantId)
  );
};

export const isProductSaved = (
  items: SavedItems,
  productId: number,
  variantId?: number,
): boolean => {
  const itemsArray =
    items.savedItemIds.length > 0
      ? items.savedItemIds
      : items.savedItemProducts;

  return itemsArray.some((item) => matchesProduct(item, productId, variantId));
};

export const findSavedItem = (
  items: SavedItems,
  productId: number,
  variantId?: number,
): SavedItem | undefined => {
  return items.savedItemProducts.find((item) =>
    matchesProduct(item, productId, variantId),
  );
};
